module.exports = __webpack_public_path__ + "2c2deef8.png";